import { type ReactElement } from 'react';
import { StackedMetricsStatusChartSection } from '@/features/shared/components/chartPanels/StackedMetricsStatusChartSection';
import { getChartTitle } from '@/shared/copy/charts';
import { getEmptyStateMessage } from '@/shared/copy/emptyStates';
import type { MetricCardItem } from '@/features/metrics/components/statusMetricCards';
import type { MetricsStatusChartPanelModelToolbarState } from '@/features/shared/components/chartPanels/useMetricsStatusChartPanelModel';
import type { MetricsToolbarTagOption } from '@/features/shared/components/metricsToolbar/metricsToolbarTagOptions';
import type { TableStatusOption } from '@/features/shared/components/tableSystem/tableToolbar.types';
import type { SuiteRunStatus } from '@flowqa/shared';

type SuitesPageStatusSectionProps = {
  availableTags: MetricsToolbarTagOption[];
  filterStatuses: SuiteRunStatus[];
  groupErroredWithFailed: boolean;
  loading: boolean;
  metricCards: MetricCardItem[];
  projectId: string | null;
  sharedChartToolbarState: MetricsStatusChartPanelModelToolbarState<SuiteRunStatus>;
  statusOptions: Array<TableStatusOption<SuiteRunStatus>>;
  suppressAnimation: boolean;
  showPoints: boolean;
  onStatusToggle: (status: string) => void;
};

export const SuitesPageStatusSection = ({
  availableTags,
  filterStatuses,
  groupErroredWithFailed,
  loading,
  metricCards,
  projectId,
  sharedChartToolbarState,
  statusOptions,
  suppressAnimation,
  showPoints,
  onStatusToggle,
}: SuitesPageStatusSectionProps): ReactElement => (
  <StackedMetricsStatusChartSection<SuiteRunStatus>
    title={getChartTitle('statusTimeline')}
    searchAriaLabel="Search stacked suite chart data"
    noRowsBaseText={getEmptyStateMessage('entity.noneFound', { entity: 'suiteRun' })}
    scope="suite"
    projectId={projectId}
    availableTags={availableTags}
    metricCards={metricCards}
    loading={loading}
    statusCardSkeletonCount={groupErroredWithFailed ? 4 : 5}
    selectedStatusIds={filterStatuses}
    onStatusToggle={onStatusToggle}
    toolbarState={sharedChartToolbarState}
    statusOptions={statusOptions}
    statusFilterLabel={getChartTitle('status')}
    suppressAnimation={suppressAnimation}
    showPoints={showPoints}
    includeLatestQuickFilter
  />
);
